import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class HubGetIndexesRequest extends BaseServiceRequest {
    constructor(symbol) {
        super();
        super.addRequestParameter("symbol", symbol);
        super.addRequestUri("getindexes.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.HUB;
    }

    getMessageName() {
        return "ConstituentsDataResponse";
    }
}

export default HubGetIndexesRequest;
